import React, { useState } from 'react';
import { useBooks } from '../context/BookContext';
import Calendar from '../components/Calendar';
import { Clock } from 'lucide-react';

const Journal = () => {
  const { logs, books, addLog } = useBooks();
  const [minutes, setMinutes] = useState(30);
  const [selectedBookId, setSelectedBookId] = useState('');
  const [notes, setNotes] = useState('');

  const handleLogSubmit = (e) => {
    e.preventDefault();
    const selectedBook = books.find(b => b.id === selectedBookId);

    addLog({
      date: new Date().toISOString().split('T')[0],
      minutes: parseInt(minutes),
      title: selectedBook ? selectedBook.title : 'General Reading',
      book_id: selectedBookId || null,
      notes: notes.trim() || null,
    });

    setNotes('');
    alert('Session logged!');
  };

  const readingBooks = books.filter(b => b.status === 'reading');

  return (
    <div>
      <h2>Reading Log</h2>
      
      <div style={{ marginBottom: '2rem' }}>
        <Calendar logs={logs} />
      </div>

      <div style={formCardStyle}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '1rem' }}>
          <Clock size={20} color="#4caf50" />
          <h3 style={{ margin: 0 }}>Log a Session</h3>
        </div>

        <form onSubmit={handleLogSubmit}>
          <div style={inputGroup}>
            <label style={labelStyle}>What are you reading?</label>
            <select 
              value={selectedBookId} 
              onChange={(e) => setSelectedBookId(e.target.value)}
              style={inputStyle}
            >
              <option value="">General Reading</option>
              {readingBooks.map(book => (
                <option key={book.id} value={book.id}>{book.title}</option>
              ))}
            </select>
          </div>

          <div style={inputGroup}>
            <label style={labelStyle}>How many minutes?</label>
            <input 
              type="number" 
              value={minutes} 
              onChange={(e) => setMinutes(e.target.value)}
              style={inputStyle}
            />
          </div>

          <div style={inputGroup}>
            <label style={labelStyle}>Quote or note (optional — appears as a scroll on your shelf 📜)</label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="A line that struck you, or a thought from today's reading..."
              style={{ ...inputStyle, minHeight: '72px', resize: 'vertical', fontFamily: 'inherit' }}
            />
          </div>

          <button type="submit" style={buttonStyle}>
            Save Session
          </button>
        </form>
      </div>

      <div style={{ marginTop: '2rem' }}>
        <h3>Recent History</h3>
        {logs.length === 0 ? (
          <p style={{ color: '#999' }}>No sessions logged yet.</p>
        ) : (
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {logs.slice(-5).reverse().map(log => (
              <li key={log.id} style={{ ...historyItemStyle, flexDirection: 'column', display: 'flex', gridTemplateColumns: undefined }}>
                <div style={{ display: 'grid', gridTemplateColumns: '100px 1fr 50px', fontSize: '0.9rem' }}>
                  <span>{log.date}</span>
                  <strong>{log.title}</strong>
                  <span>{log.minutes}m</span>
                </div>
                {log.notes && (
                  <div style={{ fontSize: '0.8rem', color: '#888', fontStyle: 'italic', marginTop: '4px', paddingLeft: '4px', borderLeft: '2px solid #ccc' }}>
                    📜 "{log.notes}"
                  </div>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

const formCardStyle = {
  backgroundColor: 'white',
  padding: '1.5rem',
  borderRadius: '12px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
  border: '1px solid #eee'
};

const inputGroup = {
  marginBottom: '1rem'
};

const labelStyle = {
  display: 'block',
  fontSize: '0.8rem',
  color: '#666',
  marginBottom: '4px'
};

const inputStyle = {
  width: '100%',
  padding: '10px',
  borderRadius: '6px',
  border: '1px solid #ddd',
  fontSize: '1rem',
  boxSizing: 'border-box'
};

const buttonStyle = {
  width: '100%',
  padding: '12px',
  backgroundColor: '#4caf50',
  color: 'white',
  border: 'none',
  borderRadius: '6px',
  fontSize: '1rem',
  fontWeight: 'bold',
  cursor: 'pointer'
};

const historyItemStyle = {
  display: 'grid',
  gridTemplateColumns: '100px 1fr 50px',
  padding: '10px 0',
  borderBottom: '1px solid #eee',
  fontSize: '0.9rem'
};

export default Journal;
